import React, { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import PaymentForm from "../../PaymentForm/BackupPaymentForm"; // Ensure correct path
import parse from "html-react-parser";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import './buyticket.css';

const BuyTicket = ({ webpageData, data, carouselRef }) => {
    const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedTicketType, setSelectedTicketType] = useState("");

    const ticketData = webpageData?.ticketSection || {};

    const handleBuyNowClick = (ticketType) => {
        setSelectedTicketType(ticketType);
        setShowPaymentModal(true);
    };

    const handleClosePaymentModal = () => {
        setShowPaymentModal(false);
    };

    const renderTicketCard = (ticket, index) => (
        <div key={index} className={`buy-ticket-card buy-ticket-card-${ticket.cardTheme} ${
            ticket.title === "General Admission" ? "general-admission-header" : ""
          }`}>
            <div className="buy-ticket-card-header">
                <h4 className="buy-ticket-card-title">{ticket.title}</h4>
                <h3 className={`buy-ticket-card-price ${ticket.cardTheme === 'dark' ? 'light-accent' : ''}`}>
                    {ticket.price}
                    {ticket.earlybirdlogo && (
                        <Image
                            src={`${imgCDNURL}${ticket.earlybirdlogo}`}
                            alt="Early Bird Logo"
                            className="earlybird-logo"
                            loading="lazy"
                        />
                    )}
                </h3>
            </div>
            <div className="buy-ticket-card-features">
                {ticket.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="buy-ticket-feature">
                        <div className={`buy-ticket-checkmark ${ticket.cardTheme === 'light' ? 'white-check' : 'green-check'}`}></div>
                        <p className={`buy-ticket-feature-text ${ticket.cardTheme === 'dark' ? 'text-color-changes' : ''}`}>
                            {feature}
                        </p>
                    </div>
                ))}
            </div>
            <div className="buy-ticket-card-footer">
                <Button
                    className={`buy-ticket-button buy-ticket-${ticket.cardTheme === 'light' ? 'primary' : 'tertiary'}-button`}
                    onClick={() => handleBuyNowClick(ticket.type)}
                >
                    {ticket.buttonText}
                </Button>
            </div>
        </div>
    );

    const responsiveMobile = {
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 2
          },
          mobile: {
            breakpoint: { max: 767, min: 0 },
            items: 1.2
          }
    };

    return (
        <>
            <div className="buy-ticket-div" id="register-section">
                <Container className="buy-ticket-container">
                    <Row>
                        <Col xs={12} md={10} lg={3} className="buy-ticket-card-col" id="general-admission-card">
                            <h3 className="buy-ticket-title">{parse(ticketData.title || "")}</h3>
                            <p className="buy-ticket-subtitle mt-4">{parse(ticketData.description || "")}</p>
                            <p className="buy-ticket-newsubtitle">{parse(ticketData.newdescription || "")}</p>
                        </Col>

                        {/* DESKTOP VIEW ONLY */}
                        <Col lg={9} className="d-none d-lg-flex buy-ticket-cards-section">
                            {ticketData.tickets && ticketData.tickets.map((ticket, index) => (
                                <Col
                                    key={index}
                                    lg={4}
                                    className="buy-ticket-card-col"
                                    id={`${ticket.type.toLowerCase().replace(/\s+/g, "-")}-card`}
                                >
                                    {renderTicketCard(ticket, index)}
                                </Col>
                            ))}
                        </Col>
                    </Row>

                    {/* MOBILE VIEW ONLY */}
                    <div className="d-block d-lg-none mt-4">
                        <Carousel
                        ref={carouselRef}
                            responsive={responsiveMobile}
                            swipeable
                            draggable
                            showDots={false}
                            arrows={false}
                            infinite={true}
                            keyBoardControl
                            containerClass="carousel-container"
                            itemClass="carousel-item-padding-40-px-new"
                        >
                            {ticketData.tickets && ticketData.tickets.map((ticket, index) => (
                                <div key={index} className="buy-ticket-carousel-item">
                                    {renderTicketCard(ticket, index)}
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </Container>

                {/* Modal for Payment Form */}
                <Modal
                    show={showPaymentModal}
                    onHide={handleClosePaymentModal}
                    size="lg"
                    aria-labelledby="payment-form-modal"
                    centered
                    backdrop="static"
                    dialogClassName="payment-form-modal"
                    contentClassName="payment-form-modal-content"
                >
                    <Modal.Body>
                        <PaymentForm
                            data={data}
                            closeForm={handleClosePaymentModal}
                            ticketType={selectedTicketType}
                            showCloseButton={true}
                            onPaymentSuccess={(transactionId, stripeSessionId) => {
                            }}
                            webpageData={webpageData}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default BuyTicket;
